import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BrandLogo from "../../../../_uLearn/assets/media/uLearn-logo.png.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Authentication } from "../../../../utils/string";
const CreatePassword = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.style.height = "100%";
    }
    return () => {
      if (root) {
        root.style.height = "auto";
      }
    };
  }, []);
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[0-9]/, "Password must contain at least one number")
      .matches(
        /^\S*$/,
        "Password must not contain spaces or special characters"
      )
      .notOneOf(["password", "12345678"], "Password is too common")
      .required("Password is required"),
  });
  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      navigate("/auth/login");
    },
  });
  return (
    <div className="d-flex flex-column flex-root bg-white">
      <div className="d-flex flex-column flex-lg-row-fluid py-10">
        <div className="">
          <Link
            to="/"
            className="mb-12 position-absolute top-0 start-0 mt-10 ms-10"
          >
            <img alt="Logo" src={BrandLogo} className="h-40px" />
          </Link>
        </div>
        <div className="d-flex flex-center pt-lg-0 pt-15 flex-column flex-column-fluid">
          <div className="w-lg-475px p-8 p-md-10 p-lg-15 mx-auto">
            <form
              className="form w-100"
              action="/auth/login"
              onSubmit={formik.handleSubmit}
            >
              <div className="mb-4 text-center">
                <h1 className="text-dark fs-36 mb-3 fw-bold">
                  {Authentication.CreatePassword}
                </h1>
                <div className="text-dark fs-16 fw-500">
                  {Authentication.CreateText}
                  <br></br>
                </div>
              </div>
              <div className="d-flex flex-wrap mb-2 justify-content-center">
                <div className="d-flex flex-wrap">
                  <div className="input-group input-group-solid h-60px border-0 bg-light w-375px ">
                    <input
                      type="password"
                      className={`form-control form-control-lg border-0 bg-light text-dark fs-16 fw-500 ${
                        formik.touched.password && formik.errors.password
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Password"
                      autoComplete="off"
                      {...formik.getFieldProps("password")}
                    />
                    <span
                      className="input-group-text fs-16 fw-500 text-dark bg-light border-0 "
                      id="basic-addon1"
                    >
                      {/* <i className="fas fa-eye"></i> */}
                    </span>
                  </div>
                  {formik.touched.password && formik.errors.password && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        <span role="alert">{formik.errors.password}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="text-center pt-3">
                <button
                  type="submit"
                  id="kt_sign_in_submit"
                  className="btn btn-primary br-8 w-lg-375px h-60px"
                  disabled={!formik.isValid}
                >
                  <span className="indicator-label fs-16 fw-600">
                    {Authentication.CreatePasswordButton}
                  </span>
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="d-flex flex-center flex-wrap fs-6 p-5 pb-0">
          <div className="d-flex flex-center  fs-16">
            <span>
              {Authentication.GoBack}
              <Link to="/auth/login" className="text-primary fs-16 fw-500">
                &nbsp;Sign in
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export { CreatePassword };
